import { Model } from "@/models";

export default class IndicatorDistribution extends Model {
  static type = "indicatorDistributions";
  options: string[];
}
